const items = [
  "Commerce de gros non alimentaire",
  "Négoce interentreprises",
  "Sourcing France & international",
  "Devis sous 48 h ouvrées",
  "Pantin · Seine-Saint-Denis",
  "RCS Bobigny 995 401 502",
  "Facturation professionnelle en euros",
];

export const Marquee = ({ dark = false }) => (
  <div className={`relative overflow-hidden border-y py-5 ${dark ? "border-white/10 bg-night text-white/70" : "border-line bg-white text-slate"}`} aria-hidden="true" data-testid="marquee">
    <div className="flex w-max animate-marquee gap-12 whitespace-nowrap font-heading text-sm font-semibold uppercase tracking-[0.22em]">
      {[...items, ...items].map((t, i) => (
        <span key={i} className="inline-flex items-center gap-12">
          {t}
          <span className="h-1.5 w-1.5 rounded-full bg-gold" />
        </span>
      ))}
    </div>
  </div>
);
